export class LegacyVegreferanse {
    constructor(
        readonly fylke: number,
        readonly kommune: number,
        readonly kategori: string,
        readonly status: string,
        readonly vegnummer: number,
        readonly hp: number,
        readonly meter: number,
        readonly kortform: string
    ) {}
}
